import { render } from "./BoxIntegration.vue?vue&type=template&id=da2d2bc6&scoped=true"
import script from "./BoxIntegration.vue?vue&type=script&lang=js"
export * from "./BoxIntegration.vue?vue&type=script&lang=js"

import "./BoxIntegration.vue?vue&type=style&index=0&id=da2d2bc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da2d2bc6"]])

export default __exports__